import { render, staticRenderFns } from "./ProjectOffersList.vue?vue&type=template&id=030f8049&scoped=true"
import script from "./ProjectOffersList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectOffersList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProjectOffersList.vue?vue&type=style&index=0&id=030f8049&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030f8049",
  null
  
)

export default component.exports